import {
  fileKeyToDownloadUrl,
  AppointmentStatus,
  DatabaseEntities,
  makeEntitySettings
} from '@satellite/../nova/core';

// initial state
const state = {
  warehouse: {},
  org: {},
  logoPath: '/images/opendock_loadsmart_logo.png'
};

// getters
const getters = {
  warehouseId(state) {
    return state.warehouse?.id;
  },
  warehouseName(state) {
    return state.warehouse?.name;
  },
  warehouseOrgName(state) {
    return state.warehouse?.org?.name;
  },
  warehouseOrgId(state) {
    return state.warehouse?.orgId;
  },
  warehouseAddress(state) {
    let address = '';
    if (state.warehouse?.id) {
      address += `${state.warehouse?.street}, ${state.warehouse?.city}, ${state.warehouse?.state} ${state.warehouse?.zip}`;
    }
    return address;
  },
  warehouseInstructions(state) {
    return state.warehouse?.instructions || 'There are currently no warehouse instructions.';
  },
  warehousePhone(state) {
    return state.warehouse?.phone || 'N/A';
  },
  warehouseEmail(state) {
    return state.warehouse?.email || 'N/A';
  },
  warehouseTimezone(state) {
    return state.warehouse?.timezone;
  },
  warehouseSchedule(state) {
    return state.warehouse?.schedule;
  },
  warehouseAmenities(state) {
    return state.warehouse?.amenities;
  },
  warehousePpeRequirements(state) {
    return state.warehouse?.ppeRequirements;
  },
  consolidatedSettings(state) {
    return makeEntitySettings(DatabaseEntities.Warehouse, state.warehouse || state.org);
  },
  orgWarehouseName(state) {
    return `${state.org?.name} - ${state.warehouse?.name}`;
  },
  logoPath(state) {
    return state.logoPath;
  },
  customLogoPath(state, getters) {
    // Use warehouseLogo first, then orgLogo
    const orgLogo = state.org?.settings?.customLogo;
    const warehouseLogo = state.warehouse?.settings?.customLogo;
    const logo = warehouseLogo ?? orgLogo;

    return logo ? fileKeyToDownloadUrl(getters.s3BaseUrl, logo) : null;
  },
  appointmentCreationStatus(state) {
    return state.warehouse?.settings?.appointmentCreationStatus ?? AppointmentStatus.Scheduled;
  }
};

// actions
const actions = {};

// mutations
const mutations = {
  setWarehouse(state, warehouse) {
    this.$app.$updateObjectInLocalStorage('warehouse', warehouse);
    state.warehouse = warehouse;
    state.org = warehouse.org;
  }
};

export default {
  namespaced: true,
  name: 'App',
  state,
  getters,
  actions,
  mutations
};
